module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAAXNSR0IB2cksfwAAABVQTFRFAAAAH3b/H3b/IHD/H3b/IHb/H3b/W4dSfwAAAAd0Uk5TANDPEP/S025KzvwAAABASURBVHicYxAyYGBWYhBRZjByZDB0MlYRZmAWCXU0YGAwc0lmYGAwdQlmYGBWSXMyACowBioTEQYqYxAE6hIEANqHB0CLEuUTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-alert--channels--exit.png
// module id = 757
// module chunks = 0